import David from '../../assets/testimonials/david.jpeg'
import Amaka from '../../assets/testimonials/amaka.jpeg'
import Daniel from '../../assets/testimonials/daniel.jpeg'
import Zainab from '../../assets/testimonials/zainab2.jpeg'
import Mich from '../../assets/testimonials/michael.jpeg' 

export const testimonials = [
  {
    name: "David Okafor",
    star: "⭐⭐⭐⭐⭐",
    rating: 5,
    sector: "Founder, LuxeFit Apparel",
    quote: "I needed a Shopify store that actually converts, not just something that looks good. GraceTech handled everything from design to product setup, and within the first few weeks, I started getting consistent orders. The structure of the store made a huge difference.",
    testImg: David
  },
  {
    name: "Amaka Nwoye",
    star: "⭐⭐⭐⭐⭐",
    rating: 5,
    sector: "CEO, GlowSkin Beauty",
    quote: "What impressed me most was how they understood my brand. The website feels premium, clean, and easy to navigate. My customers now trust my business more, and I’ve seen a noticeable increase in inquiries.",
    testImg: Amaka
  },
  {
    name: "Daniel Carter",
    star: "⭐⭐⭐⭐⭐",
    rating: 5,
    sector: "Startup Founder, SaaS Product",
    quote: "I came with just an idea, and GraceTech turned it into a working product. They didn’t just build what I asked — they improved it. The UI, performance, and overall experience exceeded what I expected.",
    testImg: Daniel
  },
  {
    name: "Zainab Musa",
    star: "⭐⭐⭐⭐⭐",
    rating: 5,
    sector: "Social Media Manager, TrendSpace",
    quote: "Our previous website was slow and confusing. After the redesign, everything feels smooth and professional. We now get more engagement, and clients take us more seriously.",
    testImg: Zainab
  },
  {
    name: "Michael Thompson",
    star: "⭐⭐⭐⭐⭐",
    rating: 5,
    sector: "E-commerce Brand Owner",
    quote: "GraceTech focused on what actually matters — conversions. From the layout to the checkout flow, everything was optimized for sales. It’s not just a website, it’s a tool that brings in revenue.",
    testImg: Mich
  }
];